<template>
  <main id="filter-property-result-main" :class="{ boxPadding: isBox }">
    <div class="container-fluid" :class="{ 'section-loading': insLoading }">
      <section> 
         <h4 class="text-red ml-custom">※以下資訊係由產險提供，如有錯誤須透過產險保單批註/變更
          <div class="dropdown float-right">
            <button class="btn btn-default btn-sm m-0" aria-expanded="false" aria-haspopup="true"  data-toggle="dropdown" @click="dropmenuOpen = !dropmenuOpen">功能<i v-if="dropmenuOpen===false" class="icon-collapse_down"></i><i v-else class="icon-collapse_up"></i></button>
            <div class="dropdown-menu  dropdown-menu-left">
              <a @click="toSearchFilter" role="button" class="dropdown-item text-green text-underline">修改條件</a>
            </div>
          </div>
        </h4>
      </section>   
      <div class="tab-pane pt-3 active show">
        <div>
          <div v-show="showCathayCarIns">
            <div>
              <div class="row">
                <div class="mt-4 mb-2 box boxGreen"></div>
                <h4 class="mt-4 mb-2">國泰產險-車險</h4>
                <a @click="detailToggle('CathayCarInsurance')" role="button" class="btn btn-icon btn-sm icon-collapse"
                  :class="isShowCathayCarInsuranceContent
                    ? 'btn-primary'
                    : 'btn-default'
                    ">
                  <i :class="isShowCathayCarInsuranceContent
                    ? 'icon-collapse_up'
                    : 'icon-collapse_down'
                    "></i>
                </a>
              </div>
              <div class="insurance-row row" v-if="isShowCathayCarInsuranceContent">
                <div class="car-insurance-hint text-red">以下為投保當時的保單資訊，僅供參考，實際保障內容請以最新保單、批單所載資訊為準。</div>
                <table id="cathay-car-insurance" class="table datatable insurance-green">
                  <thead>
                    <tr>
                      <th width="140" class="sorting" @click="columnSorting(true, 'cathayCar', 'no')" :class="tableOrder.cathayCar.fieldSorting == 'no'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        保單號碼
                      </th>
                      <th width="120" class="sorting" @click="columnSorting(true, 'cathayCar', 'type')" :class="tableOrder.cathayCar.fieldSorting == 'type'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        契約別
                      </th>
                      <th width="90" class="sorting" @click="
                        columnSorting(true, 'cathayCar', 'client')
                        " :class="tableOrder.cathayCar.fieldSorting == 'client'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        被保人
                      </th>
                      <th width="150" class="sorting" @click="
                        columnSorting(
                          true,
                          'cathayCar',
                          'startAt',
                          false,
                          'endWith'
                        )
                        " :class="tableOrder.cathayCar.fieldSorting == 'startAt'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        有效期間
                      </th>
                      <th width="60" class="text-right sorting" @click="columnSorting(true, 'cathayCar', 'fee')" :class="tableOrder.cathayCar.fieldSorting == 'fee'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        保費
                      </th>
                      <th width="*" class="sorting" @click="columnSorting(true, 'cathayCar', 'carNo')" :class="tableOrder.cathayCar.fieldSorting == 'carNo'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        車牌號碼
                      </th>
                      <th width="60" class="sorting" @click="
                        columnSorting(true, 'cathayCar', 'engineNo')
                        " :class="tableOrder.cathayCar.fieldSorting == 'engineNo'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        引擎號碼
                      </th>
                      <th class="sorting" @click="
                        columnSorting(true, 'cathayCar', 'carType')
                        " :class="tableOrder.cathayCar.fieldSorting == 'carType'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        車種
                      </th>
                      <th class="sorting" @click="
                        columnSorting(true, 'cathayCar', 'carYear')
                        " :class="tableOrder.cathayCar.fieldSorting == 'carYear'
                        ? tableOrder.cathayCar.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        發照日
                      </th>
                      <th v-if="insuranceEditMode">編輯</th>
                    </tr>
                  </thead>
                  <tbody v-if="cathayCarApiReturnCode === 0">
                    <tr v-for="(insure, i) in insuranceEditMode
                      ? insurance.cathayCar.filter(
                        (el) => el.isSelfInput
                      )
                      : insurance.cathayCar" :key="`cathay-car-${i}`">
                      <!-- <td v-if="!insure.cepln.includes('TCH1') && !insure.cepln.includes('TCH2') "><a @click="carsDetail(insure.no)" class="link text-underline">{{insure.no}}</a></td> -->
                      <td v-if="!insure.cepln.includes('TCH1') &&
                        !insure.cepln.includes('TCH2')
                        ">
                        <!-- <a @click="carsDetail(insure.no)" class="link text-underline">{{ insure.no }}</a> -->
                        {{ insure.no | getMaskPolicyNumber}}
                      </td>
                      <td v-else>{{ insure.no | getMaskPolicyNumber}}</td>
                      <td>{{ insure.type }}</td>
                      <td>
                        {{ getTruncateText(insure.client, 12, false) | getMaskName }}
                        <!-- <a
                              v-if="
                                stringBytes(insure.client, false, 12) > 12
                              "
                              class="link text-underline"
                              role="button"
                              @hover="currentName = insure.client"
                              @click="clickPopOver(insure.client)"
                              v-popover:namePop.top
                            >
                              ...
                            </a> -->
                      </td>
                      <td>
                        <b>起</b>
                        {{ insure.startAt | dateFormat }}{{ " " + insure.startAtTime }}
                        <br />
                        <b>訖</b>
                        {{ insure.endWith | dateFormat }}{{ " " + insure.endWithTime }}
                      </td>
                      <td class="text-right">
                        <div>{{ insure.fee | numberFormat2 }}</div>
                      </td>
                      <td>
                        <a>{{ insure.carNo }}</a>
                      </td>
                      <td>
                        <a>{{ insure.engineNo }}</a>
                      </td>
                      <td>
                        <div>{{ insure.carType }}</div>
                      </td>
                      <td>
                        <div>{{ insure.carYear }}</div>
                      </td>
                      <td v-if="insuranceEditMode">
                        <div>
                          <a role="button" class="text-red text-underline" @click="deleteSelfInput(insure)">
                            刪除
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td :colspan="9" class="empty-block bg-white">
                        <h3 class="bg-white">查無資料</h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-show="showCathayFireIns">
            <div>
              <div class="row">
                <div class="mt-4 mb-2 box boxGreen"></div>
                <h4 class="mt-4 mb-2">國泰產險-火險</h4>
                <a @click="detailToggle('CathayFireInsurance')" role="button" class="btn btn-icon btn-sm  icon-collapse"
                  :class="isShowCathayFireInsuranceContent
                    ? 'btn-primary'
                    : 'btn-default'
                    ">
                  <i :class="isShowCathayFireInsuranceContent
                    ? 'icon-collapse_up'
                    : 'icon-collapse_down'
                    "></i>
                </a>
              </div>

              <div class="insurance-row row" v-if="isShowCathayFireInsuranceContent">
                <div class="car-insurance-hint text-red">以下為投保當時的保單資訊，僅供參考，實際保障內容請以最新保單、批單所載資訊為準。</div>
                <table id="cathay-fire-insurance" class="table datatable insurance-green">
                  <thead>
                    <tr>
                      <th width="140" class="sorting" @click="columnSorting(true, 'cathayFire', 'no')" :class="tableOrder.cathayFire.fieldSorting == 'no'
                        ? tableOrder.cathayFire.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        保單號碼
                      </th>
                      <th width="*" class="sorting" @click="columnSorting(true, 'cathayFire', 'type')" :class="tableOrder.cathayFire.fieldSorting == 'type'
                        ? tableOrder.cathayFire.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        契約別
                      </th>
                      <th width="100" class="sorting" @click="
                        columnSorting(true, 'cathayFire', 'client')
                        " :class="tableOrder.cathayFire.fieldSorting == 'client'
                        ? tableOrder.cathayFire.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        被保人
                      </th>
                      <th width="150" class="sorting" @click="
                        columnSorting(
                          true,
                          'cathayFire',
                          'startAt',
                          false,
                          'endWith'
                        )
                        " :class="tableOrder.cathayFire.fieldSorting == 'startAt'
                        ? tableOrder.cathayFire.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        有效期間
                      </th>
                      <th class="text-right sorting" @click="columnSorting(true, 'cathayFire', 'fee')" :class="tableOrder.cathayFire.fieldSorting == 'fee'
                        ? tableOrder.cathayFire.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        保費
                      </th>
                      <th class="text-right sorting" @click="
                        columnSorting(true, 'cathayFire', 'add_prem')
                        " :class="tableOrder.cathayFire.fieldSorting == 'add_prem'
                        ? tableOrder.cathayFire.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        附加險總保費
                      </th>
                      <th class="sorting" @click="
                        columnSorting(true, 'cathayFire', 'address')
                        " :class="tableOrder.cathayFire.fieldSorting == 'address'
                        ? tableOrder.cathayFire.asc
                          ? 'sorting_asc'
                          : 'sorting_desc'
                        : ''
                        ">
                        標的地址
                      </th>
                      <th v-if="insuranceEditMode">編輯</th>
                    </tr>
                  </thead>
                  <tbody v-if="cathayFireApiReturnCode === 0">
                    <tr v-for="(insure, i) in insuranceEditMode
                      ? insurance.cathayFire.filter(
                        (el) => el.isSelfInput
                      )
                      : insurance.cathayFire" :key="`cathay-fire-insure-${i}`">
                      <td>
                        <!-- <a @click="fireDetail(insure.no)" class="link text-underline">{{ insure.no }}</a> -->
                        {{ insure.no | getMaskPolicyNumber}}
                      </td>
                      <!-- <td>{{insure.no}}</td> -->
                      <td>{{ insure.type }}</td>
                      <td>
                        {{ getTruncateText(insure.client, 12, false) | getMaskName }}
                        <!-- <a
                              v-if="
                                stringBytes(insure.client, false, 12) > 12
                              "
                              class="link text-underline"
                              role="button"
                              @hover="currentName = insure.client"
                              @click="clickPopOver(insure.client)"
                              v-popover:namePop.top
                            >
                              ...
                            </a> -->
                      </td>
                      <td>
                        <b>起</b>
                        {{ insure.startAt | dateFormat }}&nbsp;{{ insure.ceplcdt_time }}
                        <br />
                        <b>訖</b>
                        {{ insure.endWith | dateFormat }}&nbsp;{{ insure.celpsdt_time }}
                      </td>
                      <td class="text-right">
                        <a>{{ insure.fee | numberFormat2 }}元</a>
                      </td>
                      <td class="text-right">
                        <a>{{ insure.add_prem | numberFormat2 }}元</a>
                      </td>
                      <td>
                        <div>{{ insure.address | getMaskAddress}}</div>
                      </td>
                      <td v-if="insuranceEditMode">
                        <div>
                          <a role="button" class="text-red text-underline" @click="deleteSelfInput(insure)">
                            刪除
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td :colspan="9" class="empty-block bg-white">
                        <h3 class="bg-white">查無資料</h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import { commonMixin } from "../../../mixins/common";
import { queryPropertyInsurance } from "@/service";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import loadHighchartsMore from "highcharts/highcharts-more";
import { setTimeout } from "timers";
import {
  disableBodyScroll,
} from "body-scroll-lock";


loadHighchartsMore(Highcharts);
exportingInit(Highcharts);
exportData(Highcharts);


export default {
  name: "FilterPropertyResult",
  mixins: [commonMixin],
  data() {
    return {
      tableOrder: {
        cathayCar: {
          //國泰產險-車險
          fieldSorting: "no",
          asc: true,
        },
        cathayFire: {
          //國泰產險-火險
          fieldSorting: "no",
          asc: true,
        },
      },
      dropmenuOpen: false,
      filters: [],
      insuranceEditMode: false,
      insuranceComplete: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      order: {
        order_by: 0,
        order_asc: true,
      },
      otherOrder: {
        order_by: 0,
        order_asc: true,
      },
      insurance: {
        cathayCar: [],
        cathayFire: [],
      },
      isShowCathayCarInsuranceContent: true,
      isShowCathayFireInsuranceContent: true,
      showCathayCarIns: false,
      showCathayFireIns: false,
      cathayCarApiReturnCode: 0,
      cathayFireApiReturnCode: 0,
      insLoading: false
    };
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo", "RouterPara"]),

    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === "box";
    },
  },
  methods: {
    ...mapMutations([
      "updateAllFamilyResult",
      "updateFamilyResultFilter",
      "updateUserItems",
    ]),
    ...mapActions(["setPageLock", "updateCustID"]),
    filterBeforePolicies(policies) {
      //當天之前失效保單不顯示
      //20220221 過濾暫時移除
      const toDay = new Date();
      // return policies
      //   ? policies.filter(
      //       (item) => new Date(item.CELPSDT || item.celpsdt) > toDay
      //     )
      //   : [];
      return policies ? policies : [];
    },
    detailToggle(item) {
      if (item == "CathayCarInsurance") {
        this.isShowCathayCarInsuranceContent = !this.isShowCathayCarInsuranceContent;
      } else if (item == "CathayFireInsurance") {
        this.isShowCathayFireInsuranceContent = !this.isShowCathayFireInsuranceContent;
      }
    },
    toSearchFilter(){  // 修改條件
      let filterPropertyResult = this.RouterPara.filterPropertyResult
      this.$router.push({ path: '/search-filter', query: filterPropertyResult })
    },
    columnSorting(
      isCathayInsu,
      tableName,
      fieldName,
      fieldIsArray = false,
      secondFieldName = null,
      indexOfFirstField = 0,
      indexOfSecondField = 1
    ) {
      if (isCathayInsu) {
        let isMultyField = secondFieldName ? ` & ${secondFieldName}` : "";
        console.log(
          `>>>>> sortTarget: insurance.${tableName} ;sortField: ${fieldName}${isMultyField} ;fieldIsArray: ${fieldIsArray} <<<<<`
        );
      } else {
        let isMultyField = secondFieldName ? ` & ${secondFieldName}` : "";
        console.log(
          `>>>>> sortTarget: ${tableName} ;sortField: ${fieldName}${isMultyField} ;fieldIsArray: ${fieldIsArray} <<<<<`
        );
      }

      //切換表頭圖案
      if (this.tableOrder[tableName].fieldSorting == fieldName) {
        this.tableOrder[tableName].asc = !this.tableOrder[tableName].asc;
      } else {
        this.tableOrder[tableName].asc = true;
      }
      this.tableOrder[tableName].fieldSorting = fieldName;

      //data排序
      if (isCathayInsu) {
        if (fieldIsArray) {
          this.insurance[tableName].sort(
            this.sortCompareByAryFieldFun(
              this.tableOrder[tableName].asc,
              fieldName,
              indexOfFirstField,
              secondFieldName,
              indexOfSecondField
            )
          );
        } else {
          this.insurance[tableName].sort(
            this.sortCompareByFieldFun(
              this.tableOrder[tableName].asc,
              fieldName,
              secondFieldName
            )
          );
        }
      } else {
        if (fieldIsArray) {
          this[tableName].sort(
            this.sortCompareByAryFieldFun(
              this.tableOrder[tableName].asc,
              fieldName,
              indexOfFirstField,
              secondFieldName,
              indexOfSecondField
            )
          );
        } else {
          if (tableName == "suggestionList") {
            //商品建議書
            this.suggestionList.forEach((eachSuggestion) => {
              eachSuggestion.sort(
                this.sortCompareByFieldFun(
                  this.tableOrder[tableName].asc,
                  fieldName,
                  secondFieldName
                )
              );
            });
          } else {
            this[tableName].sort(
              this.sortCompareByFieldFun(
                this.tableOrder[tableName].asc,
                fieldName,
                secondFieldName
              )
            );
          }
        }
      }
    },
    sortCompareByAryFieldFun(
      isAsc,
      mainProperty,
      mainPropertyIndex = 0,
      subProperty = null,
      subPropertyIndex = 1
    ) {
      let sortOrder = 1;
      if (!isAsc) {
        sortOrder = -1;
      }
      return function (a, b) {
        let result =
          a[mainProperty][mainPropertyIndex] <
            b[mainProperty][mainPropertyIndex]
            ? -1
            : a[mainProperty][mainPropertyIndex] >
              b[mainProperty][mainPropertyIndex]
              ? 1
              : 0;
        if (result == 0 && subProperty != null) {
          result =
            a[subProperty][subPropertyIndex] < b[subProperty][subPropertyIndex]
              ? -1
              : a[subProperty][subPropertyIndex] >
                b[subProperty][subPropertyIndex]
                ? 1
                : 0;
        }
        return result * sortOrder;
      };
    },
    sortCompareByFieldFun(isAsc, mainProperty, subProperty = null) {
      let sortOrder = 1;
      if (!isAsc) {
        sortOrder = -1;
      }
      return function (a, b) {
        let result =
          a[mainProperty] < b[mainProperty]
            ? -1
            : a[mainProperty] > b[mainProperty]
              ? 1
              : 0;
        if (result == 0 && subProperty != null) {
          result =
            a[subProperty] < b[subProperty]
              ? -1
              : a[subProperty] > b[subProperty]
                ? 1
                : 0;
        }
        return result * sortOrder;
      };
    },
    checkInsloading() {
      if (!this.insuranceComplete.includes(0)) {
        this.insLoading = false;
      }
      this.registerHanlink(); // for 難字更新
    },
    deleteSelfInput(ins) {
      this.deleteSuccessHandler(
        deleteSelfInputPropertyNumber(this.$store.state.userInfo.id, ins.no, "")
      );
    },
    deleteSuccessHandler(fn) {
      return new Promise((resolve) => {
        fn.then((res) => {
          if (res.header && res.header.status === "200") {
            this.$toast.info({ title: "刪除成功" });
            this.initCustomerDetail4();
            resolve();
          } else {
            this.$toast.info({ title: "刪除失敗" });
          }
        });
      });
    },
    getPropertyInsurance() {
      this.insLoading = true;
      this.selection = []
      let conditionsObj = new Object;
      if (this.RouterPara.filterPropertyResult && this.RouterPara.filterPropertyResult[0].field_name) {
        this.RouterPara.filterPropertyResult.forEach(item => {
          let eachCondition = item
          if (eachCondition.title && this.filters.indexOf(eachCondition.title) === -1) {
            this.filters.push(eachCondition.title)
          }
          conditionsObj[eachCondition.field_name] = eachCondition.option
        })
      } else {
        this.$store.state.filterData.forEach(item => {
          let eachCondition = item
          if (eachCondition.title && this.filters.indexOf(eachCondition.title) === -1) {
            this.filters.push(eachCondition.title)
          }
          conditionsObj[eachCondition.field_name] = eachCondition.option
        })
      }
      this.getFiltersProdCode(); //設定filtersProdCode
      conditionsObj['order_asc'] = this.order.order_asc ? 1 : 2;//2020/06/01 增加排序條件
      conditionsObj['order_by'] = this.order.order_by;
      this.remoteDataMsg = "資料讀取中，請稍候..."
      let option_ch = this.filters.join(';')

      queryPropertyInsurance(this.$store.state.userInfo.id, conditionsObj, option_ch).then(result => {
        this.insLoading = false;
        if (result.header.status && result.header.status == '200') {

          let resBody = result.body || {};
          let carInsuranceArray = resBody.carinsurancedata
          let fireInsuranceArray = resBody.fireinsurancedata

          if (conditionsObj.plc1_month !== undefined)
            this.showCathayCarIns = true
          if (conditionsObj.plf1_month !== undefined)
            this.showCathayFireIns = true

          //車險續保資料處理
          if (carInsuranceArray.length > 0) {

            if (carInsuranceArray[0].returnmsg === 'nodata') {
              this.cathayCarApiReturnCode = -1
            } else {
              let concatData = [].concat(
                this.filterBeforePolicies(
                  carInsuranceArray.map((el) => {
                    el["isSelfInput"] = true;
                    return el;
                  })
                )
              );
              this.insurance.cathayCar = concatData.map((item) => {
                let expirationDate = "1"; //生效日期 ceplcdt, 失效日期 celpsdt
                let date = (item.lic_date + "").split("");
                date.splice(-2, 0, "/");
                date = date.join("");
                return {
                  id: item.ceisdno, //客戶代號 ceisdno
                  no: item.ceplcno, //合約號碼 ceplcno
                  name: item.cepln_nm || "", //產品名稱 cepln_nm
                  client: item.ceisdnm || "", //被保險人 ceisdnm
                  type: item.cepln_nm || "", //契約別
                  startAt: item.ceplcdt || "", //生效日期 ceplcdt
                  startAtTime: item.ceplcdt_time || "", //生效時間 ceplcdt_time
                  endWith: item.celpsdt || "", //失效日期 celpsdt
                  endWithTime: item.celpsdt_time || "", //失效時間 celpsdt_time
                  years: expirationDate,
                  fee: parseInt(item.premium) || "", //保險費 premium
                  carType: item.veh_name || "", //車種 veh_name
                  carNo: item.lic_no || "", //車牌號碼 lic_no
                  engineNo: item.eg_no || "", //引擎號碼 ???
                  carYear: date || "", //發照年月 lic_date
                  cepln: item.cepln || "", //產品代號
                  isSelfInput: item.isSelfInput ? true : false, //是否為自行輸入
                };
              });

              this.insurance.cathayCar.sort(
                this.sortCompareByFieldFun(
                  true,
                  'client',
                  'no'
                )
              );
            }

          }

          //火險續保資料處理
          if (fireInsuranceArray.length > 0) {

            if (fireInsuranceArray[0].returnmsg === 'nodata') {
              this.cathayFireApiReturnCode = -1
            } else {
              let concatData = [].concat(
                this.filterBeforePolicies(
                  fireInsuranceArray.map((el) => {
                    el["isSelfInput"] = true;
                    return el;
                  })
                )
              );

              this.insurance.cathayFire = concatData.map((item) => {
                let expirationDate = "1"; //生效日期 ceplcdt, 失效日期 celpsdt
                return {
                  no: item.ceplcno, //合約號碼 ceplcno
                  name: item.cepln_nm || "", //產品名稱 cepln_nm
                  client: item.ceisdnm || "", //被保險人 ceisdnm
                  type: item.cepln_nm || "",
                  startAt: item.ceplcdt || "", //生效日期 ceplcdt
                  ceplcdt_time: item.ceplcdt_time || "", //生效時間 ceplcdt_time
                  endWith: item.celpsdt || "", //失效日期 celpsdt
                  celpsdt_time: item.celpsdt_time || "", //失效時間 celpsdt_time
                  years: expirationDate,
                  fee: parseInt(item.premium1) || "", //保險費 premium
                  add_prem: parseInt(item.add_prem === '0.00' ? '0' : item.add_prem), //附加險保險費
                  buildYear: item.celpsdt || "",
                  address: item.address || "", //標的地址 address
                  isSelfInput: item.isSelfInput ? true : false, //是否為自行輸入
                };
              });

              this.insurance.cathayFire.sort(
                this.sortCompareByFieldFun(
                  true,
                  'client',
                  'no'
                )
              );
            }
          }

        } else {
          this.$toast.info({ title: '「產險續保查詢失敗」' })
          this.insurance.cathayFire = [];
          this.insurance.cathayCar = [];
        }

        this.insuranceComplete[7] = 1;
        this.insuranceComplete[8] = 1;
        this.checkInsloading();

      })
    },
    //取得主(附)約商品中文名稱
    getFiltersProdCode() {
      this.filtersProdCode = [];
      this.filters.forEach(item => {
        if (!item || item == "undefined") return;
        let mainCode = item.indexOf('主約');
        let subCode = item.indexOf('附約');
        let prodTypeMain = item.indexOf('已投商品:');
        if (mainCode !== -1 && subCode !== -1) {
          //有主約&附約
          let mainText = item.substring(mainCode + 3, subCode).split(':').map(m => {
            let mainAry = this.$store.state.prodMainCode.filter(main => { return main.val == m });
            let chkMainAry = mainAry && mainAry.length > 0 ? true : false;
            return {
              text: chkMainAry ? mainAry[0].text : m
            }
          })
          let subText = item.substring(subCode + 3, item.length).split(':').map(s => {
            let subAry = this.$store.state.prodSubCode.filter(main => { return main.val == s });
            let chkSubAry = subAry && subAry.length > 0 ? true : false;
            return {
              text: chkSubAry ? subAry[0].text : s
            }
          })
          let filterStr = prodTypeMain !== -1 ? '已投商品:主約:' : '未投商品:主約';
          mainText.forEach(mt => { filterStr += mt.text + ':' });
          filterStr += '附約:';
          subText.forEach(st => { filterStr += st.text + ':' });
          this.filtersProdCode.push(filterStr.substring(0, filterStr.length - 1));
        } else if (mainCode !== -1) {
          //只有主約
          let mainText = item.substring(mainCode + 3, item.length).split(':').map(m => {
            let mainAry = this.$store.state.prodMainCode.filter(main => { return main.val == m });
            let chkMainAry = mainAry && mainAry.length > 0 ? true : false;
            return {
              text: chkMainAry ? mainAry[0].text : m
            }
          })
          let filterStr = prodTypeMain !== -1 ? '已投商品:主約:' : '未投商品:主約';
          mainText.forEach(mt => { filterStr += mt.text + ':' });
          this.filtersProdCode.push(filterStr.substring(0, filterStr.length - 1));
        } else if (subCode !== -1) {
          //只有附約
          let subText = item.substring(subCode + 3, item.length).split(':').map(s => {
            let subAry = this.$store.state.prodSubCode.filter(main => { return main.val == s });
            let chkSubAry = subAry && subAry.length > 0 ? true : false;
            return {
              text: chkSubAry ? subAry[0].text : s
            }
          })
          let filterStr = prodTypeMain !== -1 ? '已投商品:附約:' : '未投商品:附約';
          subText.forEach(st => { filterStr += st.text + ':' });
          this.filtersProdCode.push(filterStr.substring(0, filterStr.length - 1));
        } else {
          //非商品類別條件，直接塞值
          this.filtersProdCode.push(item);
        }
      })
    },

  },
  beforeDestroy() {
    localStorage.oldOtherInsuranceArray = "";
    localStorage.oldOtherInsChildArray = "";
    localStorage.oldMotorInsuranceArray = "";
    localStorage.oldFireInsuranceArray = "";
    localStorage.oldCasualtyInsuranceArray = "";
    localStorage.otherDifference = "";
    localStorage.motorDifference = "";
    localStorage.fireDifference = "";
    localStorage.casualtyDifference = "";
  },

  async mounted() {
    let isChrome = window.navigator.userAgent.indexOf("Chrome") !== -1;
    let version = this.iOSversion();
    if (version === 13 && isChrome) {
      disableBodyScroll($("#filter-property-result-main table"));
    }

    this.getPropertyInsurance();

    this.$forceUpdate();
    setTimeout(() => {
      if (this.prevRoute === "self-input-property-number") {
        this.createInsurance("button");
      }
    }, 300);
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.name;
    });
  },
};
</script>

<style scoped>
.boxPadding {
  padding-top: 0px !important;
}

.table tbody tr.bg-orange {
  background: #feeedd;
}

.font-13 {
  font-size: 13px;
}

.icon-collapse {
  margin-block-start: 1.6em;
  margin-bottom: 0.45rem;
  font-size: 15px;
}

.box {
  float: left;
  height: 24px;
  width: 8px;
  margin-right: 8px;
  clear: both;
}

.boxGreen {
  background-color: #027a39;
}

.boxBlue {
  background-color: #007ab1;
}

.boxRed {
  background-color: #de4054;
}

.health-insurance-hint {
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.car-insurance-hint {
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.ml-custom{
  margin-left: -20px;
}
</style>